import { useEffect, useState } from "react";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPromisedData } from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const PAYMENT_MODES = {
  CASH: "Cash",
  CHEQUE: "CHKL",
};

export const useFetchBankAccount = (businessAreasDispValue, paymentMode= PAYMENT_MODES.CASH) => {
  const [bankDetails, setBankDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Reset state when dependency changes
    setBankDetails(null);
    setError(null);
    if (!businessAreasDispValue) return;
    const fetchDetails = async () => {
      setIsLoading(true);
      try {
        const url = `${endpoint.bankAccount}/${businessAreasDispValue}`;

        // 3. Proper await usage
        const [buBanks, allBanks] = await Promise.all([
          fetchAllPromisedData(url), 
          fetchAllPromisedData(endpoint.getHouseBankList),
        ]);
      debugger;
        const cashBankEntry = buBanks?.find(
          (item) => item.paymentModeDispVal === paymentMode && item.status === 'ACTIVE'
        );

        if (!cashBankEntry?.houseBankId) {
          console.warn(`No House Bank ID found for ${paymentMode} mode`);
          return;
        }

        const matchedBank = allBanks?.find(
          (item) => item.id === cashBankEntry.houseBankId
        );

        setBankDetails(matchedBank || null);
      } catch (err) {
        if (err) {
          console.error("Failed to fetch bank details:", err);
          setError(err);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchDetails();
  }, [businessAreasDispValue]); // 6. Correct Dependency Array

  // 7. Return comprehensive state
  return { bankDetails, isLoading, error };
};

export const useFetchBankAccounts = () => {
  const [bankAccounts, setBankAccounts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllBankAccounts = async () => {
      setIsLoading(true);
      try {
        const allBanks = await fetchAllPromisedData(endpoint.getHouseBankList);
        setBankAccounts(allBanks || []);
      } catch (err) {
        if (err) {
          console.error("Failed to fetch all bank accounts:", err);
          setError(err);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllBankAccounts();
  }, []); // Empty dependency array to run only once on mount
  
  return { bankAccounts, isLoading, error };
}